import React, { useState } from 'react';
import { Input, Button, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Select, SelectItem } from "@heroui/react";
import { Icon } from "@iconify/react";

const YearQuarterInput = ({ 
    label, 
    value, 
    onChange, 
    isReadOnly = false, 
    icon = "lucide:calendar",
    errorMessage 
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [tempYear, setTempYear] = useState('');
    const [tempQuarter, setTempQuarter] = useState('');

    // Parsear el valor actual si existe
    const parseValue = (val) => {
        if (!val) return { year: '', quarter: '' };
        const match = val.match(/^(\d{4})-Q([1-4])$/);
        if (match) {
            return { year: match[1], quarter: match[2] };
        }
        return { year: '', quarter: '' };
    };

    const currentValue = parseValue(value);
    
    // Generar años disponibles (actual -2 a actual +2)
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 2; i <= currentYear + 2; i++) {
        years.push({
            value: i.toString(),
            label: i.toString()
        });
    }

    // Quarters disponibles
    const quarters = [
        { value: "1", label: "Q1" },
        { value: "2", label: "Q2" },
        { value: "3", label: "Q3" },
        { value: "4", label: "Q4" }
    ];

    const handleOpen = () => {
        if (isReadOnly) return;
        setTempYear(currentValue.year);
        setTempQuarter(currentValue.quarter);
        setIsOpen(true);
    };

    const handleSave = () => {
        if (tempYear && tempQuarter) {
            const newValue = `${tempYear}-Q${tempQuarter}`;
            onChange(newValue);
        }
        setIsOpen(false);
    };

    const handleCancel = () => {
        setIsOpen(false);
    };

    const getDisplayValue = () => {
        if (currentValue.year && currentValue.quarter) {
            return `${currentValue.year}-Q${currentValue.quarter}`;
        }
        return "Seleccionar año y quarter";
    };

    return (
        <div className="w-full">
            <Input
                label={label}
                value={getDisplayValue()}
                isReadOnly={true}
                onClick={handleOpen}
                startContent={
                    <Icon
                        icon={icon}
                        className="text-default-400 pointer-events-none flex-shrink-0"
                    />
                }
                endContent={null}
                classNames={{
                    label: "text-sm font-medium",
                    input: "text-sm cursor-pointer",
                }}
                className={isReadOnly ? "" : "cursor-pointer"}
            />

            <Modal isOpen={isOpen} onClose={handleCancel} size="sm">
                <ModalContent>
                    <ModalHeader className="flex flex-col gap-1">
                        Seleccionar Año y Quarter
                    </ModalHeader>
                    <ModalBody>
                        <div className="space-y-4">
                            <Select
                                label="Año"
                                selectedKeys={tempYear ? [tempYear] : []}
                                onSelectionChange={(keys) => {
                                    const year = Array.from(keys)[0];
                                    setTempYear(year);
                                }}
                                placeholder="Seleccionar año"
                                classNames={{
                                    label: "text-sm font-medium",
                                    trigger: "h-12",
                                    value: "text-sm",
                                }}
                            >
                                {years.map((year) => (
                                    <SelectItem key={year.value} value={year.value}>
                                        {year.label}
                                    </SelectItem>
                                ))}
                            </Select>
                            
                            <Select
                                label="Quarter"
                                selectedKeys={tempQuarter ? [tempQuarter] : []}
                                onSelectionChange={(keys) => {
                                    const quarter = Array.from(keys)[0];
                                    setTempQuarter(quarter);
                                }}
                                placeholder="Seleccionar quarter"
                                classNames={{
                                    label: "text-sm font-medium",
                                    trigger: "h-12",
                                    value: "text-sm",
                                }}
                            >
                                {quarters.map((quarter) => (
                                    <SelectItem key={quarter.value} value={quarter.value}>
                                        {quarter.label}
                                    </SelectItem>
                                ))}
                            </Select>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" variant="light" onPress={handleCancel}>
                            Cancel
                        </Button>
                        <Button 
                            color="primary" 
                            onPress={handleSave}
                            isDisabled={!tempYear || !tempQuarter}
                        >
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {errorMessage && (
                <p className="text-danger text-xs mt-1">{errorMessage}</p>
            )}
        </div>
    );
};

export default YearQuarterInput; 